import React from 'react';
import Page from './components/page/index';

const Application: React.FC<any> = (props: any) => {
    return <Page />;
}

export default Application;